import { gql } from '@apollo/client'
import { VehicleNodeFragment } from './Fragments'

export const vehicles = gql`
  query vehicles {
    vehicles {
      edges {
        node {
          ...vehicleNode
        }
      }
    }
  }
  ${VehicleNodeFragment}
`
